import { v4 as uuidv4 } from 'uuid';
import vendor1 from '../../assets/img/vendors/Forging-Vendors.jpg';
import vendor2 from '../../assets/img/vendors/Machining-Vendors.jpg';
import vendor3 from '../../assets/img/vendors/Sheet-Metal-Vendors.jpg';
import vendor4 from '../../assets/img/vendors/Extrusion-Vendors.jpg';
import vendor5 from '../../assets/img/vendors/Surface-Treatment-Vendors.jpg';
import vendor6 from '../../assets/img/vendors/Heat-Treatment-Vendors.jpg';
import vendor7 from '../../assets/img/vendors/Fabrication-Vendors.jpg';

const teamData = [
    {
        id: uuidv4(),
        img: vendor1,
        name: 'Forging Vendors',
        position: 'Founder',
        fbLink: '/',
        twitterLink: '/',
        behanceLink: '/',
        youtubeLink: '/',
    },

    {
        id: uuidv4(),
        img: vendor2,
        name: 'Machining Vendors',
        position: 'CEO',
        fbLink: '/',
        twitterLink: '/',
        behanceLink: '/',
        youtubeLink: '/',
    },

    {
        id: uuidv4(),
        img: vendor3,
        name: 'Sheet Metal Vendors',
        position: 'Designer',
        fbLink: '/',
        twitterLink: '/',
        behanceLink: '/',
        youtubeLink: '/',
    },

    {
        id: uuidv4(),
        img: vendor4,
        name: 'Extrusion Vendors',
        position: 'Support Engineer',
        fbLink: '/',
        twitterLink: '/',
        behanceLink: '/',
        youtubeLink: '/',
    },

    {
        id: uuidv4(),
        img: vendor5,
        name: 'Surface Treatment Vendors',
        position: 'Support Engineer',
        fbLink: '/',
        twitterLink: '/',
        behanceLink: '/',
        youtubeLink: '/',
    },

    {
        id: uuidv4(),
        img: vendor6,
        name: 'Heat Treatment Vendors',
        position: 'Developer',
        fbLink: '/',
        twitterLink: '/',
        behanceLink: '/',
        youtubeLink: '/',
    },

    {
        id: uuidv4(),
        img: vendor7,
        name: 'Fabrication Vendors',
        position: 'Developer',
        fbLink: '/',
        twitterLink: '/',
        behanceLink: '/',
        youtubeLink: '/',
    },
];

export default teamData;
